import React, { useState, useEffect } from 'react';
import blow from "../assets/image/bolwing-arrow.png";
import rocket from "../assets/image/rocket.png";
import money from "../assets/image/money.png";
import Team1 from "../assets/image/founder1.png";
import ArrowBg from "../component/ArrowBg";
import Whitearow from "../assets/arrow3.png";
import bigrow from "../assets/whitearow2.png";
import Vector from "../assets/image/Vector1.png";
import { CheckCircle } from 'lucide-react';
import { BadgeCheck } from "lucide-react";

export default function Contact(){

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
const [isSubmitted, setIsSubmitted] = useState(false);

  

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 const [formData, setFormData] = useState({
    name: '',
    dob: '',
    email: '',
    phone: '',
    pincode: '',
    employmentType: ''
  });


  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleInputChange = (e) => {
    setIsSubmitted(false);
    setIsLoading(false);

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get all input elements
    const inputs = e.currentTarget.parentElement.querySelectorAll('input, select');
    let isValid = true;

    // Check each input
    inputs.forEach(input => {
      if (!input.validity.valid) {
        isValid = false;
        input.reportValidity();
      }
    });

    if (!isValid) return;

    setIsLoading(true);

    try {
      // Send email using EmailJS
      const templateParams = {
        from_name: 'Loan Inquiry',
        to_email: 'bhargav@reapcapital.in',
        subject: "You've just received a new submission.",
        name: formData.name,
        dob: formData.dob,
        email: formData.email,
        phone: formData.phone,
        pincode: formData.pincode,
        employment_type: formData.employmentType,
        message: `Name: ${formData.name}
DOB: ${formData.dob}
Email: ${formData.email}
Phone: ${formData.phone}
Pincode: ${formData.pincode}
Salaried/Self employed: ${formData.employmentType}`
      };

      // Using EmailJS REST API
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
             service_id: 'service_7f0rbhr', // Replace with your EmailJS Service ID
          template_id: 'template_8xh5jf6', // Replace with your EmailJS Template ID
          user_id: 'MgFJ2C2MNo_B5mb2T', // Replace with your EmailJS Public Key
          template_params: templateParams
        })
      });

      if (response.ok) {
        setIsLoading(false);
        setIsSubmitted(true);
        setShowSuccessMessage(true);
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          setShowSuccessMessage(false);
        }, 5000);
        
        // Reset form after 6 seconds
        setTimeout(() => {
          setFormData({
            name: '',
            dob: '',
            email: '',
            phone: '',
            pincode: '',
            employmentType: ''
          });
          setIsSubmitted(false);
        }, 6000);
      } else {
        throw new Error('Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setIsLoading(false);
      alert('Failed to submit form. Please try again.');
    }
  };


 

  const [letterStates, setLetterStates] = useState([]);
  const [loaded, setLoaded] = useState(false);
const TEXT =
  "Empowering the MSMEs with instant access and instant solutions.";

  useEffect(() => {
  const letters = TEXT.split('');

  setLetterStates(new Array(letters.length).fill(false));

  setTimeout(() => setLoaded(true), 100);

  letters.forEach((_, index) => {
    setTimeout(() => {
      setLetterStates(prev => {
        const newState = [...prev];
        newState[index] = true;
        return newState;
      });
    }, 500 + index * 40);
  });
}, []);


const renderAnimatedText = (text, startIndex = 0) => {
  const words = text.split(" ");
  let globalIndex = startIndex;

  return words.map((word, wIndex) => {
    return (
      <span key={wIndex} className="inline-block mr-[0.3em]">
        {word.split("").map((letter, lIndex) => {
          const index = globalIndex++;

          return (
            <span
              key={lIndex}
              className={`inline-block transition-all duration-500 ${
                letterStates[index]
                  ? "opacity-100 blur-0 translate-y-0"
                  : "opacity-0 blur-md translate-y-4"
              }`}
            >
              {letter}
            </span>
          );
        })}

       
      </span>
    );
  });
};



  return (
    <>
         <div className="min-h-screen bg-black relative overflow-hidden">

      <style>{`
        @keyframes slideDownBg {
          from {
            transform: translateY(-30%);
          }
          to {
            transform: translateY(0);
          }
        }

        @keyframes floatIn {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes diagonalSlide {
          from {
            transform: translate(-200%, 200%);
            opacity: 0;
          }
          to {
            transform: translate(0, 0);
            opacity: 1;
          }
        }

        @keyframes rotateIn {
          from {
            transform: rotate(90deg) scale(0.3);
            opacity: 0;
          }
          to {
            transform: rotate(70deg) scale(1);
            opacity: 0.7;
          }
        }

        @keyframes slideFromLeft {
          from {
            transform: translateX(-150px) rotate(10deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateX(0) rotate(10deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes slideFromRight {
          from {
            transform: translateX(150px) rotate(335deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateX(0) rotate(335deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes rotateSlide {
          from {
            transform: translateX(150px) rotate(285deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateX(0) rotate(285deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes slideFromBottom {
          from {
            transform: translateY(100px) rotate(13deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateY(0) rotate(13deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            transform: scale(0.8);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes buttonFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }

        .hero-bg-animate {
          animation: slideDownBg 1s ease-out;
        }

        .text-float {
          animation: floatIn 0.8s ease-out;
        }

        .button-animate {
          animation: floatIn 1s ease-out 2s both;
        }

         .object-1 {
          animation: slideFromLeft 1s ease-out 0.5s both;
        }

        .object-2 {
          animation: slideFromTop 1s ease-out 0.7s both;
        }

        .object-3 {
          animation: slideFromBottom 1s ease-out 0.9s both;
        }

        .object-4 {
          animation: slideFromRight 1.2s ease-out 1.1s both;
        }

        .image-card-animate {
          animation: diagonalSlide 1.2s ease-out 0.8s both;
        }

        .arrow-top-left {
          animation: rotateIn 1s ease-out 0.5s both;
        }

        .rocket-animate {
          animation: slideFromLeft 1.2s ease-out 1s both;
        }

        .money-bottom-right {
          animation: slideFromRight 1s ease-out 1.2s both;
        }

        .arrow-mid-right {
          animation: rotateSlide 1s ease-out 1.4s both;
        }

        .money-bottom-left {
          animation: slideFromBottom 1s ease-out 1.6s both;
        }

        .bg-gradient-radial {
          background: radial-gradient(ellipse at top center, #149D64 0%, #0B6351 10%);
        }

        /* DEFAULT State */
        .button-default {
          box-shadow:
            0 0 0 0.9px #47ffd48e,
            inset 0 0 20px rgba(25, 180, 140, 1.0),
            inset 0 0 10px rgba(42, 157, 114, 0.7);
        }

        /* HOVER State */
        .button-default:hover {
          box-shadow:
            0 0 0 4px #47ffd48e,
            inset 0 0 0px rgba(0, 0, 0, 0),
            inset 0 0 0px rgba(0, 0, 0, 0);
        }

        /* Decorative elements subtle float animation */
        .float-gentle {
          animation: floatGentle 3s ease-in-out infinite;
        }

        @keyframes floatGentle {
          0%, 100% {
            transform: translateY(0) rotate(var(--rotate, 0deg));
          }
          50% {
            transform: translateY(-10px) rotate(var(--rotate, 0deg));
          }
        }

        .float-gentle-2 {
          animation: floatGentle2 4s ease-in-out infinite;
        }

        @keyframes floatGentle2 {
          0%, 100% {
            transform: translateY(0) rotate(var(--rotate, 0deg));
          }
          50% {
            transform: translateY(-15px) rotate(var(--rotate, 0deg));
          }
        }
      `}</style>
  {/* Main Content */}
  <section id="contact" className="w-full h-fit bg-black overflow-hidden relative">
     
    <div
      className="
        w-full h-fit
        bg-emerald-700
        rounded-bl-[60px] rounded-br-[60px]
        overflow-hidden relative hero-bg-animate
        pl-[12px] pr-[12px]
        pt-[160px] pb-[60px]
        sm:pl-[12px] sm:pr-[12px] sm:pt-[140px] sm:pb-[120px]
        md:pl-[30px] md:pr-[28px] md:pt-[170px] md:pb-[80px]
        lg:pt-[170px] lg:pb-[80px] lg:pl-[0px] lg:pr-[0px] lg:rounded-bl-[50px] lg:rounded-br-[50px]
      "
      style={{
        width: "100%",
        height: "100%",
        background:
          "radial-gradient(ellipse at top center, #149D64 0%, #0B6351 100%)",
      }}
    >
      <div className=' absolute bg-cover bg-center top-96 md:top-80 lg:top-14 -right-60 md:-right-80  lg:-right-2 w-[800px] h-[750px] md:w-[800px] md:h-[750px] lg:w-[750px] lg:h-[750px]  overflow-visible'style={{ backgroundImage: `url(${Vector})` }} >
         </div>
      
      <div className="max-w-[1280px] mx-auto px-2.5 sm:px-2 md:px-2 lg:px-10 relative z-10 text-center md:text-left">

        {/* ⭐ Fixed Grid */}
        <div className="grid sm:grid md:grid  lg:grid-cols-[1fr_auto] gap-12 items-stretch">

          {/* Left Side */}
          <div className="text-white w-full mt-0 lg:mt-14">
            <h1 className="text-[34px] md:text-[43px] font-inter lg:text-[53px] leading-tight font-normal max-w-[681px]  md:max-w-[680px] lg:max-w-[1280px] mb-6 tracking-[-1.44px]">
              {renderAnimatedText("Empowering the MSMEs with instant access and instant solutions.", 0)}
            </h1>

            <div className="space-y-4">
  {/* Row 1 */}
  <div className="flex items-center w-full text-left gap-3">
  <div className="w-fit h-fit rounded-full flex items-center justify-center">
    <BadgeCheck className="text-white w-6 h-6" />
  </div>

  <p
    className="text-emerald-100 text-base sm:text-lg md:text-lg lg:text-lg w-full text-left"
    style={{ animationDelay: '1.8s', animationFillMode: 'both' }}
  >
    From Approval to Account – Instantly

  </p>
</div>
  {/* Row 2 */}
 <div className="flex items-center w-full text-left gap-3">
  <div className="w-fit h-fit rounded-full flex items-center justify-center">
    <BadgeCheck className="text-white w-6 h-6" />
  </div>

  <p
    className="text-emerald-100 text-base sm:text-lg md:text-lg lg:text-lg w-full text-left"
    style={{ animationDelay: '1.8s', animationFillMode: 'both' }}
  >
    Fast Track Your Funding
  </p>
</div>

</div>

          </div>

          {/* Right Side - Form */}
          <div className="w-full flex justify-start items-start md:justify-end">
           
  {/* Success Message Popup */}
      {showSuccessMessage && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-slideDown">
          <div className="bg-white rounded-2xl shadow-2xl px-6 py-4 flex items-center gap-3 border border-emerald-200">
            <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span className="text-gray-800 font-medium text-base">
              Form submitted successfully! We'll contact you soon.
            </span>
          </div>
        </div>
      )}

      <div className="bg-white rounded-3xl p-5 shadow-xl w-full max-w-[1280px] md:max-w-[1280px] lg:max-w-[510px]">
        <h2 className="text-[18px] font-semibold font-inter text-black mb-4 text-left">
          Check If You're Eligible
        </h2>

        <div className="space-y-3 flex flex-col gap-2">
          {/* Name */}
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
            required
            pattern="^[A-Za-z ]+$"
            onInvalid={(e) =>
              e.target.setCustomValidity("Please fill in this field.")
            }
            onInput={(e) => e.target.setCustomValidity("")}
            className="w-full px-3 py-3 bg-[#EAEAEA] rounded-xl border border-transparent 
                       focus:ring-2 focus:ring-emerald-500 outline-none 
                       text-[#404040] font-medium text-[16px]"
          />

          {/* DOB */}
          <input
            type="date"
            name="dob"
            placeholder="Date of Birth"
            value={formData.dob}
            onChange={handleInputChange}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Please select your date of birth.")
            }
            onInput={(e) => e.target.setCustomValidity("")}
            className="w-full px-3 py-3 bg-[#EAEAEA] rounded-xl border border-transparent 
                       focus:ring-2 focus:ring-emerald-500 outline-none 
                       text-[#404040] font-medium text-[16px]"
          />

          {/* Email */}
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Please enter a valid email address.")
            }
            onInput={(e) => e.target.setCustomValidity("")}
            className="w-full px-3 py-3 bg-[#EAEAEA] rounded-xl border border-transparent 
                       focus:ring-2 focus:ring-emerald-500 outline-none 
                       text-[#404040] font-medium text-[16px]"
          />

          {/* Phone */}
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
            pattern="^[0-9]{10}$"
            onInvalid={(e) =>
              e.target.setCustomValidity(
                "Please enter a valid 10-digit phone number."
              )
            }
            onInput={(e) => e.target.setCustomValidity("")}
            className="w-full px-3 py-3 bg-[#EAEAEA] rounded-xl border border-transparent 
                       focus:ring-2 focus:ring-emerald-500 outline-none 
                       text-[#404040] font-medium text-[16px]"
          />

          {/* Pincode */}
          <input
            type="text"
            name="pincode"
            placeholder="Pincode"
            value={formData.pincode}
            onChange={handleInputChange}
            required
            pattern="^[0-9]{6}$"
            onInvalid={(e) =>
              e.target.setCustomValidity("Please enter a valid 6-digit pincode.")
            }
            onInput={(e) => e.target.setCustomValidity("")}
            className="w-full px-3 py-3 bg-[#EAEAEA] rounded-xl border border-transparent 
                       focus:ring-2 focus:ring-emerald-500 outline-none 
                       text-[#404040] font-medium text-[16px]"
          />

          {/* Employment Type */}
          <select
            name="employmentType"
            value={formData.employmentType}
            onChange={handleInputChange}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Please select employment type.")
            }
            onInput={(e) => e.target.setCustomValidity("")}
            className="w-full px-3 py-3 bg-[#EAEAEA] rounded-xl border border-transparent
                       focus:ring-2 focus:ring-emerald-500 outline-none 
                       text-[#404040] font-medium appearance-none cursor-pointer text-[16px]"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M5 7.5L10 12.5L15 7.5' stroke='%236B7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 1.25rem center",
            }}
          >
            <option value="">Salaried/Self employed</option>
            <option value="Salaried">Salaried</option>
            <option value="Self Employed">Self Employed</option>
          </select>

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            disabled={isLoading || isSubmitted}
            className={`
              w-full bg-black button-default hover:text-[#2a9d72]
              transition-all duration-300 cursor-pointer z-20 
              text-white font-semibold text-lg py-4 rounded-[18px] mt-2
              flex items-center justify-center
              ${isLoading ? "cursor-wait" : ""}
            `}
          >
            {isLoading ? (
              <div className="animate-spin h-6 w-6 border-2 border-white border-t-transparent rounded-full"></div>
            ) : isSubmitted ? (
              <h2 className="text-[#2a9d72]">Thank you</h2>
            ) : (
              "Check Eligibility Now"
            )}
          </button>

          <p className="text-[14px] font-medium text-[#404040] leading-normal mt-4 text-left">
            By clicking on Check Loan Eligibility, you agree to our T&C and Privacy Policy.
            With your authorization, (Name of the authorisation) and our trusted lending 
            partners will securely access your credit report to customise the best loan offers for you.
          </p>
        </div>
      </div>
</div>


        </div>
      </div>

      {/* Decorative Elements (unchanged) */}
         <ArrowBg className="absolute -translate-x-1/2" />

      <img src={blow} className="absolute opacity-70 rotate-[70deg] blur-sm lg:top-20 lg:left-10 w-32 " />
      <img src={rocket} alt='' className="absolute rotate-[10deg] object-contain opacity-100 bottom-5 -left-10 w-32 h-32 sm:bottom-[44%] sm:-left-[14%] sm:w-44 sm:h-44 md:bottom-0 md:-left-16 lg:bottom-16 lg:-left-20 lg:w-60 lg:h-60" />
      <img src={money} className="absolute opacity-100 blur-[2px] rotate-[335deg] object-contain w-52 h-52  -bottom-[12%] sm:-bottom-[12%] md:-bottom-[8%] lg:-bottom-[12%] right-0 lg:right-[210px]" />
      <img src={blow} className="absolute rotate-[285deg] object-contain max-w-[232px] max-h-[232px] bottom-40 -right-[10%] lg:-right-[8%]" />
      <img src={money} className="absolute rotate-[13deg] object-contain w-72 h-72 -bottom-[12%] right-[60%] sm:right-[60%] md:right-[70%] lg:right-[60%] md:-bottom-[10%] lg:-bottom-[18%]" />
    </div>
  </section>
</div>
</>
    );
  }